// API base URL configuration
// Use REACT_APP_API_URL from .env if available, otherwise default to localhost:8000
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default API_BASE_URL;
